// import styles
import "./AutomezziDashboard.css";

// import pacchetti
import Select from "react-select";
import { useState, useEffect } from "react";

export default function AutomezziFilter({ filtro, change, settori, onSearch }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [settoriOptions, setSettoriOptions] = useState([]);
  
  // Prepara le opzioni per il dropdown
  useEffect(() => {
    if (settori) {
      // Aggiungi l'opzione "Tutti" all'inizio
      const options = [
        { value: "tutti", label: "Tutti" },
        ...settori.map(settore => ({
          value: settore,
          label: settore
        }))
      ];
      setSettoriOptions(options);
    }
  }, [settori]);

  // Gestisce il cambio del filtro dal dropdown
  const handleFilterChange = (option) => {
    change(option.value);
  };

  // Gestisce il cambio del termine di ricerca
  const handleSearchChange = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
    // Passa il termine di ricerca al componente padre
    onSearch(term);
  };

  // Trova l'opzione corrente selezionata
  const currentOption = settoriOptions.find(option => option.value === filtro) || settoriOptions[0];

  return (
    <div className="automezzi-filter">
      <div className="filters-container">
        <input
          type="text"
          onChange={handleSearchChange}
          placeholder="Cerca"
          className="search-bar"
          value={searchTerm}
        />
        <div className="dropdown-filters">
          <Select
            className="filter-select"
            options={settoriOptions}
            onChange={handleFilterChange}
            value={currentOption}
            placeholder="Seleziona settore"
            isSearchable={false}
          />
        </div>
      </div>
    </div>
  );
}